import {
    OPERATOR_STATUS_UPDATED,
    OperatorApplicationEventManager,
    OperatorStatusUpdatedEventPayload
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {
    OPERATOR_APPLICATION_SOUND_OPERATOR_STATUS_CHANGE
} from "~/operatorApplication/ts/service/OperatorApplicationSoundPlayer";
import {__} from "~/ts/library/Translate";
import {getOperatorStatusDictionary} from "~/operatorApplication/ts/data/OperatorStatus";
import {OPERATOR_STATUS_OFFLINE} from "~/chat/ts/data/OperatorStatus";

export default class OperatorApplicationStatusNotifier {
    public static init() {
        OperatorApplicationEventManager.addEventListener(OPERATOR_STATUS_UPDATED, (payload: OperatorStatusUpdatedEventPayload) => {
            let operator = payload.operator;
            let previousVersion = payload.previousVersion;
            if (OperatorAccountStore.isAuthorized.value) {
                if (OperatorApplicationConfigInstance.operatorStatusChangeNotificationsEnabled) {
                    if (OperatorAccountStore.login.value != operator.login) {
                        if (operator.statusId != previousVersion.statusId || operator.customStatusId != previousVersion.customStatusId) {
                            OPERATOR_APPLICATION_SOUND_OPERATOR_STATUS_CHANGE.play(true);
                            let statusDescr = operator.customStatusId ? OperatorAccountStore.customStatusDictionary.value[operator.customStatusId]?.descr : null;
                            if (!statusDescr) {
                                statusDescr = operator.statusId != OPERATOR_STATUS_OFFLINE ? getOperatorStatusDictionary()[operator.statusId]?.descr : "offline";
                            }
                            if (statusDescr) {
                                let title = operator.fio;
                                if (OperatorAccountStore.data.value.accessRights.canViewOperatorsLogin) {
                                    title += ` (${operator.login})`;
                                }
                                OperatorApplicationPlatform.notifications.show({
                                    groupId: operator.login,
                                    title,
                                    text: __("Новый статус оператора: %s", statusDescr)
                                });
                            }
                        }
                    }
                }
            }
        });


    }
}